import apiClient from '../clienteFebosAPI';

const RESOURCE = '/notributarios';

export const clDntsList = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}?${params}`, {
    operacionId: 'io.dnts.list'
  });
};

export const clDntActFileED = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.put(`${RESOURCE}/${payload.febosId}/estado?${params}`, {
    estadoId: payload.estadoId,
    transportePuertoTipo: payload.transportePuertoTipo,
    comentario: payload.comentario
  },
  { operacionId: 'io.dnts.ed.act.estado' });
};

export const clUpdateMetadata = (febosId, metadata) => apiClient
  .post(`${RESOURCE}/${febosId}/metadata`, metadata,
    { operacionId: 'io.dnts.ed.act.estado' });

export const clDntArchiveFileED = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.put(`${RESOURCE}/${payload.febosId}/estado?${params}`,
    { estadoId: payload.estadoId, comentario: payload.comentario },
    { operacionId: 'io.dnts.ed.act.estado' });
};

export const clRecoverFile = ({ febosId, message }) => {
  const params = apiClient.queryParams({ febosId });

  return apiClient.post(`${RESOURCE}/${febosId}/expedientes/rescatar?${params}`,
    { mensaje: message },
    { operacionId: 'io.dnts.ed.rescatar' });
};

export const downloadAttachments = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.febosId}/adjuntos?${params}`,
    { operacionId: 'io.download.attachments.dnt' });
};

export const cancelFile = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.delete(`${RESOURCE}/${payload.febosId}?${params}`, {
    operacionId: 'io.cancel.dnt'
  });
};

export const clAsignFile = (febosId, view) => apiClient.post(
  `${RESOURCE}/${febosId}/destinos/asignar?view=${view}`, {}, {
    operacionId: 'io.asign.file'
  }
);

export const getFile = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.febosId}?${params}`, {
    operacionId: 'io.get.dnt'
  });
};

export const fileComments = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.febosId}/expedientes/comentarios?${params}`, {
    operacionId: 'io.dnt.comments'
  });
};

export const getProcessDocument = (febosId) => apiClient
  .get(`${RESOURCE}/${febosId}/expedientes/acta`, {
    operacionId: 'io.dnt.process.document'
  });

export const attachmentsFiles = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.febosId}/adjuntos?${params}`, {
    operacionId: 'io.dnt.attachments'
  });
};

export const fileBinnacle = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.febosId}/bitacora?${params}`, {
    operacionId: 'io.dnt.binnacle'
  });
};

export const sendComment = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.post(`${RESOURCE}/${payload.febosId}/expedientes/comentarios?${params}`,
    { comentario: payload.comentario },
    { operacionId: 'io.dnt.send.comment' });
};

export const sendFile = (payload) => apiClient.post(`${RESOURCE}/${payload.febosId}/destinos`,
  { destinos: payload.destinos },
  { operacionId: 'io.dnt.send.file' });

export const createDnt = (payload) => {
  const params = apiClient.queryParams({
    entrada: 'json',
    tipoDocumento: 'EXP',
    retornarPdf: 'no',
    simular: 'no',
    foliar: 'si'
  });

  const config = {
    operacionId: 'io.dnt.crear.dnt',
    ...(payload.company && {
      headersRequest: {
        empresa: payload.company
      }
    })
  };

  return apiClient.post(
    `${RESOURCE}/crear?${params}`,
    payload,
    config
  );
};

export const updateDnt = (id, payload) => {
  const params = apiClient.queryParams({
    entrada: 'json',
    tipoDocumento: 'EXP',
    febosId: id,
    sobreEscribir: 'si'
  });
  return apiClient.post(
    `${RESOURCE}/${id}/actualizar?${params}`,
    payload,
    { operacionId: 'io.dnt.actualizar.dnt' }
  );
};
export const indicatorFilesED = () => apiClient.get(`${RESOURCE}/0/expedientes/indicadores`, {
  operacionId: 'io.dnts.ed.indicadores.inicio'
});

export const fileTimeline = (febosId) => apiClient.get(`${RESOURCE}/${febosId}/destinos/timeline`, {
  operacionId: 'io.dnt.timeline'
});

export const clReturnFileED = (payload) => apiClient
  .post(`${RESOURCE}/${payload.febosId}/destinos/devolver`,
    { comentario: payload.comentario },
    { operacionId: 'io.dnt.return.file' });

export const activitiesFile = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.febosId}/actividades?${params}`, {
    operacionId: 'io.dnt.activities'
  });
};

export const addActivity = (payload) => apiClient.post(`${RESOURCE}/${payload.febosId}/actividades`,
  payload.activity,
  { operacionId: 'io.dnt.add.activity' });

export const updateActivity = (payload) => apiClient.put(`${RESOURCE}/${payload.febosId}/actividades`,
  payload.activity,
  { operacionId: 'io.dnt.update.activity' });

export const getSheetsConfig = (idOption) => {
  const params = apiClient.queryParams(idOption);

  return apiClient.get(`${RESOURCE}/cafs/configuraciones?${params}`, {
    operacionId: 'io.dnt.config.sheets'
  });
};

export const getNumerationFile = (idOption, groupId) => {
  const params = apiClient.queryParams({
    tipoDocId: idOption,
    alcanceId: groupId
  });

  return apiClient.get(`${RESOURCE}/cafs/configuraciones/solicitar?${params}`, {
    operacionId: 'getNumerationFile'
  });
};

export const releaseNumerationFile = (idOption) => {
  const params = apiClient.queryParams({
    febosId: idOption
  });

  return apiClient.delete(`${RESOURCE}/cafs/configuraciones/solicitar?${params}`, {
    operacionId: 'releaseNumerationFile'
  });
};

export const saveSheetsConfig = (id, config) => {
  const params = apiClient.queryParams(id);

  return apiClient.post(`${RESOURCE}/cafs/configuraciones?${params}`, config, {
    operacionId: 'saveSheetsConfig'
  });
};

export const updateSubjectsFile = (fileId, subjects) => {
  const params = apiClient.queryParams({
    id: fileId
  });
  return apiClient.put(
    `${RESOURCE}/${fileId}/destinos?${params}`,
    { destinos: subjects },
    { operacionId: 'io.dnt.actualizar.destinos' }
  );
};

export const clReturnFileEDAguasAndinas = (payload) => {
  const { archivos } = payload;
  return apiClient.post(`${RESOURCE}/${payload.febosId}/destinos/devolver`,
    { archivos },
    { operacionId: 'io.dnt.return.file' });
};

// notributarios/{id}/expedientes/informar

export const clNotifyOfFile = ({ febosId, body }) => apiClient.post(`${RESOURCE}/${febosId}/expedientes/informar`,
  body,
  { operacionId: 'io.dnt.notify.file' });

export const ioExpedientesActualizar = (id, payload) => apiClient.patch(
  `notributarios/${id}/expedientes/`,
  payload,
  { operacionId: 'io.ed.expedientes.actualizar' }
);

// /notributarios/{dnt_id}/cadena-suplencia/
export const getExpedienteSubstitutionChain = (febosId, param = {}) => {
  const params = apiClient.queryParams(param);
  return apiClient.get(
    `${RESOURCE}/${febosId}/cadena-suplencia/?${params}`,
    { operacionId: 'io.documentos.notributarios.cadena.suplencia.get' }
  );
};
